import { Badge, Icon, Text, useDisclosure } from '@chakra-ui/react'
import { InformationCircle } from '../../../utils/constants/icons'
import NewVersionModal from '../modals/NewVersionModal'
import { useAppVersions } from '../../../hooks/useSystem'

type VersionBadgeProps = {
  variant?: 'default' | 'mobile'
}

const VersionBadge = ({ variant = 'default' }: VersionBadgeProps) => {
  const { isOpen: isInfoOpen, onOpen: onInfoOpen, onClose: onInfoClose } = useDisclosure()
  const { data: versions } = useAppVersions()

  const currentVersion = versions?.[0]?.version

  if (!currentVersion) return null

  const isMobile = variant === 'mobile'

  return (
    <>
      <Badge
        as="button"
        onClick={onInfoOpen}
        display="inline-flex"
        alignItems="center"
        gap={isMobile ? '7px' : '6px'}
        px={isMobile ? '11px' : '12px'}
        py={isMobile ? '5px' : '6px'}
        bg={isMobile ? 'rgba(255, 255, 255, 0.08)' : 'secondary.500'}
        color={isMobile ? 'rgba(255, 255, 255, 0.85)' : 'white'}
        fontSize={isMobile ? '11px' : '12px'}
        fontWeight="600"
        borderRadius={isMobile ? '999px' : '10px'}
        border={isMobile ? '1px solid rgba(255, 255, 255, 0.12)' : undefined}
        boxShadow={
          isMobile
            ? 'inset 0 1px 0 rgba(255, 255, 255, 0.06)'
            : '0px 2px 4px -2px #00000005'
        }
        cursor="pointer"
        transition="background 0.2s ease-out, color 0.2s ease-out, transform 0.15s ease-out"
        textTransform="none"
        sx={
          isMobile
            ? { backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)' }
            : undefined
        }
        _hover={
          isMobile
            ? { bg: 'rgba(255, 255, 255, 0.12)', color: 'white' }
            : { color: 'secondary.50', bg: 'secondary.600' }
        }
        _active={
          isMobile
            ? { transform: 'scale(0.97)', bg: 'rgba(255, 255, 255, 0.16)' }
            : { bg: 'secondary.200' }
        }
      >
        <Icon
          viewBox="0 0 24 24"
          w={isMobile ? '12px' : '14px'}
          h={isMobile ? '12px' : '14px'}
          fill="none"
          opacity={isMobile ? 0.75 : 1}
        >
          <InformationCircle />
        </Icon>
        <Text as="span" fontWeight={isMobile ? '600' : '500'} letterSpacing={isMobile ? '0.3px' : '0.5px'}>
          v{currentVersion}
        </Text>
      </Badge>

      <NewVersionModal isOpen={isInfoOpen} onOpen={onInfoOpen} onClose={onInfoClose} autoShow={false} />
    </>
  )
}

export default VersionBadge
